import { createApp } from 'vue';
import { imageUrl } from './utils/image-url';
import WhatsOnCalendar from './whats-on-calendar.vue';
import CalendarList from './calendar-list.vue';
import CalendarListEvent from './calendar-list-event.vue';
import CalendarFilters from './calendar-filters.vue';
import CalendarPopup from './calendar-popup.vue';
import DateSelector from './date-selector.vue';
import SearchResults from './search-results.vue';

let app = null;

document.addEventListener('DOMContentLoaded', () => {
    const mountPoint = document.querySelector('#widget-bootstrap');
    if (!mountPoint) {
        console.error('Mount point #widget-bootstrap is missing.');
        return;
    }

    if (mountPoint.__vue_app__) {
        return;
    }

    const App = {
        data() {
            return {};
        },
        delimiters: ['${', '}']
    }

    app = createApp(App);

    // Provide the imageUrl function globally
    app.provide('imageUrl', imageUrl);

    app.component('whats-on', WhatsOnCalendar);
    app.component('calendar-list', CalendarList);
    app.component('calendar-list-event', CalendarListEvent);
    app.component('calendar-filters', CalendarFilters);
    app.component('calendar-popup', CalendarPopup);
    app.component('date-selector', DateSelector);
    app.component('date-selector-mobile', DateSelector);
    app.component('search-results', SearchResults);
    app.mount(mountPoint);

    mountPoint.__vue_app__ = app;
});
